"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.offerCreator.name': 'Offer Creator',
    'tools.offerCreator.description': 'Detect and complete offer/quote information from user messages including company details, taxation types, and business activities',
};
